// Bootstrap 5 range slider with a linked number input
(function (c2) {
  'use strict';

  function init(sliderSelector) {
    var $sliders = $(sliderSelector || 'input[type="range"]');

    $sliders.not('.slider-initialized').each(function () {
      const $range = $(this);
      const min = parseFloat($range.attr('min')) || 0;
      const max = parseFloat($range.attr('max')) || 100;
      const step = parseFloat($range.attr('step')) || 1;
      const units = $range.data('slider-units') || '';

      const $number = $('<input>')
        .attr('type', 'number')
        .attr('min', min)
        .attr('max', max)
        .attr('step', step)
        .attr('autocomplete', 'off')
        .val($range.val())
        .addClass('form-control form-control-sm flex-shrink-0')

      $range.addClass('flex-grow-1');
      $range.closest('div.col-lg-9').addClass('d-flex align-items-center gap-2');
      $range.after($number);

      if (units) {
        $number.after($('<span>').addClass('ms-1 text-muted small').text(units));
      }

      // Range → number
      $range.on('input', function () {
        $number.val($(this).val());
      });

      // Number → range with step-snapping and min/max clamping
      function syncNumberToRange() {
        let val = parseFloat($number.val());
        if (isNaN(val)) return;
        val = Math.round((val - min) / step) * step + min;
        val = Math.min(max, Math.max(min, val));
        $number.val(val);
        $range.val(val);
      }
      $number.on('input', _.debounce(syncNumberToRange, 300));
      $number.on('change', syncNumberToRange);

      $range.addClass('slider-initialized');
    });
  }

  c2.sliders = {
    init: init
  };

})(window.c2);
